import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import Welcome from "./components/Welcome";
import About from "./components/About";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import Skills from "./components/Skills";
import Stage from "./components/Stage";
import GoToTop from "./components/GoToTop";
const App = () => {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    document.body.className = darkMode ? "dark-mode" : "";
  }, [darkMode]);

  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };

  return (
    <div>
      <Navbar toggleTheme={toggleTheme} darkMode={darkMode} />
      <Welcome darkMode={darkMode} />
      <main className="container mt-5">
        <About darkMode={darkMode} />
        <Skills darkMode={darkMode} />
        <Stage darkMode={darkMode} />
        <Projects darkMode={darkMode} />
      </main>
      <Footer darkMode={darkMode} />
      <GoToTop darkMode={darkMode}/>
    </div>
  );
};

export default App;
